import { ShieldOff, GitFork, LayoutDashboard, UserCheck } from "lucide-react";

const BENEFITS = [
  {
    Icon: ShieldOff,
    title: "End data sprawl",
    body: "Sensitive client details — bank accounts, contact changes, signed instructions — are captured in one encrypted, access-controlled platform. No more PDFs emailed around, bank details texted to staff phones, or spreadsheets living on personal devices.",
  },
  {
    Icon: GitFork,
    title: "Segregation of duties",
    body: "The staff member who sends the request is never the one who makes the change. Every submission flows through an independent review step, creating a defensible approval chain that satisfies internal controls and auditor requirements.",
  },
  {
    Icon: LayoutDashboard,
    title: "Track and monitor in real time",
    body: "A live view of every open, pending, and completed request across your business. See who sent what, when the client opened it, whether ID was verified, and who signed it off — without chasing emails or digging through inboxes.",
  },
  {
    Icon: UserCheck,
    title: "Seamless client onboarding",
    body: "Clients receive a branded link, verify their identity with their bank in minutes, and submit exactly what you need — structured, encrypted, and ready to action. No printing, no scanning, no back-and-forth email chains.",
  },
];

export function OperationalBenefits() {
  return (
    <div className="grid sm:grid-cols-2 gap-8">
      {BENEFITS.map(({ Icon, title, body }) => (
        <div key={title} className="flex gap-4">
          <div className="w-10 h-10 rounded bg-[hsl(var(--brand-forest))]/10 flex items-center justify-center shrink-0 mt-0.5">
            <Icon className="w-5 h-5 text-[hsl(var(--brand-forest))]" />
          </div>
          <div>
            <h3 className="font-semibold text-[hsl(var(--brand-charcoal))]">{title}</h3>
            <p className="mt-2 text-sm text-[hsl(var(--brand-slate))] leading-relaxed">{body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
